import {createAction} from "@reduxjs/toolkit";
import {apis, OtsDispatch} from "../../ots-store";
import {batch} from "react-redux";

export const changeRegion = createAction<string | undefined>('regions/change');

export const changeRegionAndResetData =
  (id: string | undefined, loadBaseDataAction: () => void) =>
    async (dispatch: OtsDispatch) => {
      await dispatch(changeRegion(id));
      await dispatch(clearApiStates());
      return await dispatch(loadBaseDataAction());
    };

const clearApiStates = () => async (dispatch: OtsDispatch) => {
  batch(() => {
    apis.forEach((api) => dispatch(api.util.resetApiState()));
  });
};
